import process from "process";

/**
 * *************************************************************************************************
 * APPLICATION IMPORTS
 */
// Included with Angular CLI.
(window as any).global = window;
global.process = process;
